import { useState, useContext, useEffect, useCallback } from "react";
import AuthContext from "../context/AuthContext";
import axiosInstance from "axios";
import { useInfiniteScroll } from "../hooks/useInfiniteScroll";

import { useModal } from "../components/ModalManager";

export default function Saved() {
  const { token, user } = useContext(AuthContext);
  const [posts, setPosts] = useState([]);
  const [nextUrl, setNextUrl] = useState(`/saved/?limit=9`);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [lastFetchedTime, setLastFetchTime] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [hasFetched, setHasFetched] = useState(null);
  const FETCH_DELAY = 1000;

  const { openModal } = useModal();

  const handleLoadPosts = useCallback(() => {
    const now = Date.now();
    if (!nextUrl || loading || now - lastFetchedTime < FETCH_DELAY) return;
    if (hasMore && hasFetched) {
      setPage((prev) => prev + 1);
      setHasFetched(false);
    }
  });

  const loaderRef = useInfiniteScroll(handleLoadPosts);

  const fetchSavedPosts = async () => {
    if (!nextUrl || loading) return;
    try {
      setLoading(true);
      const res = await axiosInstance.get(nextUrl, {
        headers: { Authorization: `Token ${token}` },
      });
      setPosts((prev) => [...prev, ...res.data.results]);
      setNextUrl(res.data.next);
      setHasMore(!!res.data.next);
    } catch (err) {
      console.error("Failed to get saved posts", err);
    } finally {
      setHasFetched(true);
      setLastFetchTime(Date.now());
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchSavedPosts();
    }
  }, [page]);

  if (!posts) {
    return <p>Loading ...</p>;
  }

  return (
    <div>
      {posts.length === 0 ? (
        <p>No posts yet.</p>
      ) : (
        <div className="max-w-4xl mx-auto p-4">
          <div className="grid grid-cols-[repeat(auto-fill,minmax(250px,1fr))] gap-px border-gray-300">
            {posts.map((post) => (
              <button
                key={post.id}
                onClick={() => openModal("PostModal", { postData: post.post, isSaved: true })}
                className="focus:outline-none m-0 p-0"
              >
                <div className="w-full aspect-[3/5] overflow-hidden">
                  {post.post.media_type === "image" ? (
                    <img
                      src={post.post.media_url}
                      alt={post.post.caption}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <video className="w-full h-full object-cover">
                      <source src={post.post.media_url} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}
                </div>
              </button>
            ))}
          </div>
          <div ref={loaderRef} className="h-[1px]" />
        </div>
      )}
    </div>
  );
}
